module.exports = __webpack_public_path__ + "static/strengths.jpg";